export const showcaseSurfacePanelClassName =
  'rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] p-4';
